import { render } from "./WebView.vue?vue&type=template&id=281fcae2&ts=true"
import script from "./WebView.vue?vue&type=script&lang=ts"
export * from "./WebView.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/HeThongPVNB/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__